import React from 'react';
import { 
	func,
	object
} from 'prop-types';
import style from './style';

const MobilePresenter = ({
	sidebarProps,renderHeader,renderMain,renderFooter,...props})=>{
	return <style.Wrapper {...props}>
		<style.Header>
			{renderHeader(sidebarProps)}
		</style.Header>
		<style.MainContainer isSidebarOpen={false}>
			
			{renderMain(sidebarProps)}
		</style.MainContainer>
		<style.Footer>{renderFooter&&renderFooter()}</style.Footer>
	</style.Wrapper>;
};

MobilePresenter.propTypes = {
	sidebarProps : object.isRequired,
	renderHeader : func.isRequired,
	renderMain : func.isRequired,
	renderFooter : func
};

export default MobilePresenter;